import type { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';

/** 设备类型由 useDeviceDetect 统一检测并同步到 Redux。 */
const useIsMobile = () => useSelector((state: RootState) => state.common.deviceType === 'mobile');

export default useIsMobile;
